import {
	axiosErrorHandler,
	axiosInstance,
} from 'models/shared/helpers/axiosInstance';
import { getRefreshToken } from 'localStorage/authStorage';
import {
	LoginDto,
	LoginResponse,
	ProfileResponse,
} from 'models/auth/interfaces/auth.interface';
import { store } from 'store';
import { login, logout } from 'store/actions/user';
import { getImageUrl } from 'models/shared/helpers/imageUrl';

export const authLogin = async (user: LoginDto) => {
	const axios = axiosInstance;
	try {
		const res = await axios.post<LoginResponse>('v1/auth/login', user);
		store.dispatch(login(res.data));

		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const fetchProfile = async (token: string) => {
	try {
		const payload = JSON.parse(atob(token.split('.')[1]));

		const profile: ProfileResponse = {
			_id: payload.sub,
			name: payload.name,
			email: payload.email,
			role: payload.role || [],
			permissions: payload.permissions?.flat() || [],
			company: payload.company,
			isActive: payload.isActive,
			type: payload.type,
			vehicles: payload.vehicles || [],
		};

		try {
			const axios = axiosInstance;
			const config = {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			};
			const res = await axios.get<any>(`v1/user/${payload.sub}`, config);
			const userData = res.data;

			profile.lastName = userData.lastName;
			profile.phone = userData.phone;
			if (userData.image && userData.image.url) {
				profile.image = {
					...userData.image,
					url: getImageUrl(userData.image.url),
				};
			} else {
				profile.image = userData.image;
			}
			profile.isActive =
				userData.isActive !== undefined ? userData.isActive : true;
			profile.type = userData.type ?? profile.type;
			profile.vehicles = (userData.vehicles ?? []).map(
				(v: { _id?: string } | string) =>
					typeof v === 'object' && v !== null && '_id' in v ? v._id : String(v),
			);
		} catch (userErr) {
			throw axiosErrorHandler(userErr);
		}

		return profile;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const fetchRefresh = async () => {
	const axios = axiosInstance;
	try {
		const res = await axios.post<LoginResponse>('v1/auth/refresh', {
			refresh_token: getRefreshToken(),
		});
		store.dispatch(login(res.data));
		return res.data;
	} catch (err: any) {
		store.dispatch(logout(true));
		throw axiosErrorHandler(err);
	}
};

export const setPassword = async (data: {
	token: string;
	password: string;
}): Promise<{ success: boolean }> => {
	const axios = axiosInstance;
	try {
		const res = await axios.put<{ success: boolean }>(
			'/v1/user/password',
			data,
		);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};
